import { FOXES_STICKY_SIDEBAR_C } from '../experimentsEnum';
import { inExperiment } from '..';

export default (abTests) => inExperiment(FOXES_STICKY_SIDEBAR_C, abTests);
